import React from 'react';
import { useWebformElement } from '../utils';
import WebformElementWrapper from './WebformElementWrapper';
export const WebformText = ({ element, error }) => {
    const [, settings] = useWebformElement(element, {});
    return (<WebformElementWrapper settings={settings} error={error}>
			<div dangerouslySetInnerHTML={{ __html: settings.attributes.text || settings.attributes.markup || '' }}/>
		</WebformElementWrapper>);
};
export default WebformText;
//# sourceMappingURL=WebformText.jsx.map